import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Enregistrement des composants nécessaires
ChartJS.register(ArcElement, Tooltip, Legend, Title);

function DiagramRepartionPartage({ nbuser, conteneur, kilo }) {
  const [nbUserKilo, setNbUserKilo] = useState(0);
  const [nbUserContainer, setNbUserContainer] = useState(0);
  const [nbUserReste, setNbUserReste] = useState(0);
  const [data, setData] = useState({
    labels: ["Conteneurs", "Kilos", "Pas de partage"],
    datasets: [
      {
        data: [0, 0, 0], // Initialisation des données
        backgroundColor: ["#0d6efd", "#188754", "#dc3445"], // Couleurs
        borderColor: ["#ffffff", "#ffffff", "#ffffff"],
        borderWidth: 1,
      },
    ],
  });

  // Options pour configurer le graphique
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Diagramme de Répartition des Partages",
      },
    },
  };

  // Calcul des utilisateurs uniques
  useEffect(() => {
    const uniqueUserIdsKilo = [...new Set(kilo.map((item) => item.userId))];
    const uniqueUserIdsConteneur = [
      ...new Set(conteneur.filter((item) => item.active === true).map((item) => item.userId)),
    ];
    const resteUser = nbuser - (uniqueUserIdsConteneur.length + uniqueUserIdsKilo.length);

    setNbUserKilo(uniqueUserIdsKilo.length);
    setNbUserContainer(uniqueUserIdsConteneur.length);
    setNbUserReste(resteUser >= 0 ? resteUser : 0); // Éviter les valeurs négatives
  }, [nbuser, conteneur, kilo]);

  // Mise à jour des données pour le graphique
  useEffect(() => {
    setData({
      labels: ["Conteneurs", "Kilos", "Pas de partage"],
      datasets: [
        {
          data: [nbUserContainer, nbUserKilo, nbUserReste], // Mise à jour des données
          backgroundColor: ["#0d6efd", "#188754", "#dc3445"], // Couleurs des sections
          borderColor: ["#ffffff", "#ffffff", "#ffffff"],
          borderWidth: 1,
        },
      ],
    });
  }, [nbUserContainer, nbUserKilo, nbUserReste]);

  return (
    <div className="col-lg-5 col-xl-4">
      <div className="card shadow mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="text-primary fw-bold m-0">Diagramme de répartition de partages</h6>
          <div className="dropdown no-arrow">
            <button
              className="btn btn-link btn-sm dropdown-toggle"
              aria-expanded="false"
              data-bs-toggle="dropdown"
              type="button"
            >
              <i className="fas fa-ellipsis-v text-gray-400"></i>
            </button>
            <div className="dropdown-menu shadow dropdown-menu-end animated--fade-in">
              <p className="text-center dropdown-header">Options</p>
              <a className="dropdown-item" href="/#">
                Action
              </a>
              <a className="dropdown-item" href="/#">
                Another action
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="/#">
                Something else here
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="chart-area">
            <Pie data={data} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiagramRepartionPartage;